import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useMemo } from 'react'
import { usePsychologistAlreadyMigrated } from '../../queries'

export const usePsyaliveProfessionalFullProfile = () => {
  const { clinic, user } = useAuthContext()
  const { data: isPsychologistAlreadyMigrated } =
    usePsychologistAlreadyMigrated()

  const showNewPsychologistSearch = useMemo(() => {
    return isPsychologistAlreadyMigrated
  }, [isPsychologistAlreadyMigrated])

  return {
    clinic,
    user,
    memoized: {
      showNewPsychologistSearch,
    },
  }
}
